import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const escalateToMerchantSupport = {
  name: "escalateToMerchantSupport" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    reason: z.string().min(1),
    authEmail: z.string().email(),
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
